import { applicationActions } from '../../../controller';
import { SocketTypeEnums } from '../../../../lib/enums';

const {
	DISCONNECT,
	CONNECT,
} = SocketTypeEnums;
const {
	forceConnectSocketSuccessAction,
	forceDisconnectSocketSuccessAction,
	forceReconnectSocketSuccessAction,
	runForceReconnectingSocketStepTwoConnectAction,
} = applicationActions;

export function forceConnectSocketReceiver(socket, store) {
	const { dispatch, getState } = store;

	socket.on(CONNECT, payload => {
		const isReconnecting = getState().application.get('isReconnecting');

		if (isReconnecting) {
			dispatch(forceReconnectSocketSuccessAction(payload));
			return;
		}

		dispatch(forceConnectSocketSuccessAction(payload));
	});
}

export function forceDisconnectSocketReceiver(socket, store) {
	const { dispatch, getState } = store;

	socket.on(DISCONNECT, payload => {
		const isReconnecting = getState().application.get('isReconnecting');

		if (isReconnecting) {
			dispatch(runForceReconnectingSocketStepTwoConnectAction());
			return;
		}

		dispatch(forceDisconnectSocketSuccessAction(payload));
	});
}
